import { useCallback, useEffect, useState } from "react";

const read = (key) => {
  if (!key) return new Set();
  try {
    return new Set(JSON.parse(localStorage.getItem(key) || "[]"));
  } catch {
    return new Set();
  }
};

export function useSeals(routeId) {
  const key = routeId ? `atlas-seals-${routeId}` : null;
  const [sealed, setSealed] = useState(() => read(key));

  useEffect(() => {
    setSealed(read(key));
  }, [key]);

  const seal = useCallback(
    (index) =>
      setSealed((prev) => {
        if (prev.has(index)) return prev;
        const next = new Set(prev);
        next.add(index);
        if (key) localStorage.setItem(key, JSON.stringify([...next]));
        return next;
      }),
    [key]
  );

  return { sealed, seal };
}

export const readSealCount = (routeId) => read(`atlas-seals-${routeId}`).size;
